import {combineReducers} from '@reduxjs/toolkit';

// Shared store
import auth from '@shared/store/auth.duck';
import authMachine from '@shared/auth/authMachine.duck';
import dashboard from '@shared/store/dashboard.duck';
import notification from '@shared/store/notification.duck';
import config from '@shared/store/config.duck';
import dialog from '@shared/store/dialog.duck';
import general from '@shared/store/general.duck';
import companyStructure from '@shared/store/companyStructure.duck';
import userTags from '@shared/store/userTags.duck';
import userAvatarInfoHover from '@shared/store/userAvatarInfoHover.duck';

// Remaining shared ducks (dialog-related, not yet extracted)
import addMemberDialog from '@shared/store/addMemberDialog.duck';
import addTeamDialog from '@shared/store/addTeamDialog.duck';
import whereaboutsOptions from '@features/whereabouts/store/whereaboutsOptions.duck';

// Feature: Auth & Onboarding
import {
  registration, forgotPassword, onboarding, loginPage
} from '@features/auth';

// Feature: Whereabouts
import {
  companyMovements, editMovements, officeView, officeUsage,
  followingTeamsAndTags, dayNotes, manageDesks, carParkingMapView,
  teamMovements, departments, whereaboutsView, dailyWhereabouts, lockers
} from '@features/whereabouts';
import lineReportsWhereabouts from '@features/whereabouts/store/LineReportsWhereabouts.duck';
import favouritedUsersWhereabouts from '@features/whereabouts/store/FavouritedUsersWhereabouts.duck';
import visitorBooking from '@features/whereabouts/pages/company-movements/components/visitor-booking/data/visitorBooking.duck';
import kiosk from '@features/kiosk/data/kiosk.duck';
import signage from '@features/signage/data/signage.duck';

// Feature: Holidays
import {
  holidaysV2, holidayBooking, holidays, approvalRequests,
  holidayReports, holidayAllowances, holidayCarryOver
} from '@features/holidays';

// Feature: Desks & Offices
import {
  advanceHotDeskingSetup, deskBooking, deskReservation,
  editDesk, editOfficeLayout, weeklyDeskAvailability
} from '@features/desks';

// Feature: Meeting Rooms
import {
  roomFinder, meetingRoom, meetingRoomBookingDialog
} from '@features/meeting-rooms';

// Feature: Wall Planner
import {
  wallPlanner, wallPlannerHoverBox
} from '@features/wall-planner';

// Feature: Reporting
import {
  keyResponsibilitiesReporting
} from '@features/reporting';

// Feature: Settings
import {
  management, userManagement, editUser, setupCompany,
  payments, outlookSync, editCompany, manageUsers, addUsers,
  meetingRoomSettings, hospitalityManagement, editCompanyLayout
} from '@features/settings';

const rootReducer = combineReducers({
  // Shared
  auth,
  authMachine,
  dashboard,
  notification,
  config,
  dialog,
  general,
  companyStructure,
  userTags,
  userAvatarInfoHover,
  addMemberDialog,
  addTeamDialog,
  whereaboutsOptions,
  // Auth
  registration,
  forgotPassword,
  onboarding,
  loginPage,
  // Whereabouts
  companyMovements,
  editMovements,
  officeView,
  officeUsage,
  followingTeamsAndTags,
  dayNotes,
  manageDesks,
  carParkingMapView,
  teamMovements,
  departments,
  lockers,
  whereaboutsView,
  dailyWhereabouts,
  lineReportsWhereabouts,
  favouritedUsersWhereabouts,
  visitorBooking,
  kiosk,
  signage,
  // Holidays
  holidaysV2,
  holidayBooking,
  holidays,
  approvalRequests,
  holidayReports,
  holidayAllowances,
  holidayCarryOver,
  // Desks
  advanceHotDeskingSetup,
  deskBooking,
  deskReservation,
  editDesk,
  editOfficeLayout,
  weeklyDeskAvailability,
  // Meeting Rooms
  roomFinder,
  meetingRoom,
  meetingRoomBookingDialog,
  // Wall Planner
  wallPlanner,
  wallPlannerHoverBox,
  // Reporting
  keyResponsibilitiesReporting,
  // Settings
  management,
  userManagement,
  editUser,
  setupCompany,
  payments,
  outlookSync,
  editCompany,
  manageUsers,
  addUsers,
  meetingRoomSettings,
  hospitalityManagement,
  editCompanyLayout,
});

export default rootReducer;
